<ng-template #content>
  <div class="lna-modal-header">
    <div class="modal-title-with-tooltip">
      <h4 class="modal-title" ngbAutofocus>{{ 'pages.viewInfoRequest.invoice.markSentModal.title' | translate }}</h4>
      <app-tooltip text="invoiceMarkSent" />
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="form">
      <div class="lna-row-32 full-width">
        <label class="form-label lna">
          {{ 'pages.viewInfoRequest.invoice.markSentModal.deliveryMethod' | translate }}
          <span class="required-field">*</span>
        </label>
        <select class="form-control lna email-field-half" formControlName="actualDeliveryMethod">
          <option value="" disabled></option>
          @for (opt of deliveryOptions; track opt.value) {
            <option [value]="opt.value">{{ opt.label | translate }}</option>
          }
        </select>
      </div>
      @if (form.get('actualDeliveryMethod')?.value === 'Email') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">
            {{ 'pages.viewInfoRequest.invoice.sendEmailModal.recipient' | translate }}
            <span class="required-field">*</span>
          </label>
          <input type="text" class="form-control lna"
            [ngClass]="{ 'is-invalid': form.get('addressDetail')?.invalid && form.get('addressDetail')?.touched }"
            formControlName="addressDetail" />
          @if (form.get('addressDetail')?.invalid && form.get('addressDetail')?.touched) {
            <p class="error-message">{{ 'components.form.invalidEmail' | translate }}</p>
          }
        </div>
      }
      @if (form.get('actualDeliveryMethod')?.value === 'PostalMail') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.invoice.markSentModal.address' | translate }}</label>
          <input type="text" class="form-control lna" formControlName="addressDetail" />
        </div>
      }
      @if (form.get('actualDeliveryMethod')?.value === 'Archive') {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.invoice.markSentModal.archive' | translate }}</label>
          <select class="form-control lna" formControlName="addressDetail">
            <option value="" disabled></option>
            @for (unit of structuralUnits; track unit.id) {
              <option [value]="unit.name">{{ unit.name }}</option>
            }
          </select>
        </div>
      }
      @if (form.get('actualDeliveryMethod')?.value) {
        <div class="lna-row-32 full-width mt-16">
          <label class="form-label lna">{{ 'pages.viewInfoRequest.invoice.markSentModal.lnaNotes' | translate }}</label>
          <div class="textarea-wrapper">
            <textarea class="form-control lna" formControlName="backofficeNote" rows="3" [maxLength]="MAX_NOTE_LENGTH"></textarea>
            <p class="length" [ngClass]="{ invalid: form.get('backofficeNote')?.value?.length > MAX_NOTE_LENGTH }">
              {{ form.get('backofficeNote')?.value?.length || 0 }}/{{ MAX_NOTE_LENGTH }}
            </p>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="form.invalid || isLoading" (click)="confirm()">
      {{ 'pages.viewInfoRequest.invoice.markSentModal.save' | translate }}
    </button>
    <button class="secondary" (click)="close()">
      {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
    </button>
  </div>
</ng-template>
